// [#f7391a39 fix] Modal seletor de revisor.
// Lista usuários do módulo comercial via /admin/usuarios. Filtra por
// ativo_vendedor=true. Permite selecionar e adicionar comentário.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';

export function ModalSelecionarRevisor({ doc, onClose, onConfirmar }: {
  doc: any;
  onClose: () => void;
  onConfirmar: (revisor_email: string, comentario: string) => void;
}) {
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [selecionado, setSelecionado] = useState<string>('');
  const [comentario, setComentario] = useState('');
  const [meuEmail, setMeuEmail] = useState('');

  useEffect(() => { (async () => {
    try {
      const session = await fetchAuthSession();
      const email = ((session.tokens?.idToken?.payload as any)?.email || '').toLowerCase();
      setMeuEmail(email);
      const token = await getToken();
      const r = await axios.get(`${API_URL}/admin/usuarios`,
        { headers: { Authorization: token } });
      const data = r.data.body ? JSON.parse(r.data.body) : r.data;
      const arr = Array.isArray(data) ? data : [];
      // Filtra: vendedores ativos (=acesso ao módulo comercial), exclui o próprio
      // usuário (não pode revisar a si mesmo).
      const elegives = arr.filter((u: any) =>
        u.email
        && u.email.toLowerCase() !== email
        && u.enabled !== false
        && ((u.groups || []).includes('comercial') || (u.groups || []).includes('admin'))
      );
      setUsuarios(elegives);
    } catch (e: any) {
      alert('Erro ao carregar usuários: ' + (e.response?.data?.error || e.message));
    } finally { setLoading(false); }
  })(); }, []);

  void meuEmail;

  const filtrados = usuarios.filter(u => {
    if (!busca.trim()) return true;
    const q = busca.toLowerCase();
    return (u.email || '').toLowerCase().includes(q) ||
           (u.nome || '').toLowerCase().includes(q);
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}
      onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 8, padding: 24, width: '94%',
          maxWidth: 540, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 16, color: '#020D7F' }}>📝 Solicitar revisão</h3>
        <div style={{ fontSize: 12, color: '#666', marginBottom: 14 }}>
          <strong>{doc.numero_proposta || doc.titulo}</strong>
          <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
            Selecione um revisor da lista. Ele receberá uma notificação no sino.
          </div>
        </div>

        <input value={busca} onChange={e => setBusca(e.target.value)}
          placeholder="🔎 Buscar por nome ou e-mail..."
          autoFocus
          style={{ width: '100%', padding: '8px 12px', fontSize: 13, borderRadius: 5,
            border: '0.5px solid #ddd', boxSizing: 'border-box', marginBottom: 10 }} />

        <div style={{ flex: 1, overflow: 'auto', border: '0.5px solid #e0e0e0',
          borderRadius: 5, marginBottom: 12, maxHeight: 300 }}>
          {loading ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#888', fontSize: 12 }}>
              Carregando usuários...
            </div>
          ) : filtrados.length === 0 ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#888', fontSize: 12 }}>
              {usuarios.length === 0
                ? 'Nenhum outro vendedor cadastrado.'
                : 'Nenhum usuário encontrado.'}
            </div>
          ) : (
            filtrados.map(u => {
              const isSel = selecionado === u.email;
              return (
                <div key={u.email}
                  onClick={() => setSelecionado(u.email)}
                  style={{
                    padding: '8px 12px', cursor: 'pointer',
                    borderBottom: '0.5px solid #f0f0f0',
                    background: isSel ? '#EFF3FF' : 'transparent',
                    display: 'flex', alignItems: 'center', gap: 10,
                  }}>
                  <input type="radio" checked={isSel} readOnly />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#020D7F' }}>
                      {u.nome || u.email}
                    </div>
                    <div style={{ fontSize: 10, color: '#888' }}>
                      {u.email}
                      {u.cargo && <> · <span style={{ color: '#666' }}>{u.cargo}</span></>}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 4 }}>
          Mensagem ao revisor (opcional)
        </label>
        <textarea value={comentario} onChange={e => setComentario(e.target.value)}
          placeholder="Ex.: Verifique o quadro de serviços e o prazo. Pode arredondar valores se quiser."
          style={{ width: '100%', padding: '8px 10px', fontSize: 12, borderRadius: 5,
            border: '0.5px solid #ddd', boxSizing: 'border-box', minHeight: 60,
            resize: 'vertical', marginBottom: 12 }} />

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose}
            style={{ padding: '8px 16px', fontSize: 12, border: '0.5px solid #ddd',
              background: '#fff', color: '#555', borderRadius: 5, cursor: 'pointer' }}>
            Cancelar
          </button>
          <button onClick={() => onConfirmar(selecionado, comentario)}
            disabled={!selecionado}
            style={{ padding: '8px 22px', fontSize: 12, fontWeight: 600,
              background: selecionado ? '#7C3AED' : '#bbb', color: '#fff',
              border: 'none', borderRadius: 5, cursor: selecionado ? 'pointer' : 'not-allowed' }}>
            📝 Solicitar revisão
          </button>
        </div>
      </div>
    </div>
  );
}
